<template>
  <moodle-view
      :help="help"
      :displayed-instances="displayedInstances"
      :moodle-component="currentView.component"
      :load-action="loadAction"
      :empty-check-key="emptyCheckKey"
  >
    <v-btn id="view__button" @click="changeView" class="header__button">
      {{ currentView.changeText }}
      <v-icon color="black">{{ currentView.changeIcon }}</v-icon>
    </v-btn>
  </moodle-view>
</template>

<script>
  import { mapGetters } from 'vuex'
  import courseIcons from '../components/course/CourseTiles'
  import courseList from '../components/course/CourseList'
  import MoodleView from '@/views/MoodleGenericView'

  export default {
    name: "Moodle",
    components: {
      MoodleView
    },
    data: () => ({
      defaultView: true,
      loadAction: 'loadCourseList',
      emptyCheckKey: 'courses'
    }),
    computed: {
      ...mapGetters(['defaultMoodleViewMode', 'moodleInstances', 'displayEmptyInstances']),
      /**
       * filter empty instances and add own favorite courses instance
       *
       * @return {MoodleInstance[]}
       */
      displayedInstances: function () {
        const favoritesInstance = (this.favoriteCourses.length || this.displayEmptyInstances)
            ? {
              id: 0,
              name: this.$t('course.favorite.instanceName'),
              courses: this.favoriteCourses
            } : null
        const filteredInstance = this.moodleInstances
            .filter(instance => this.displayEmptyInstances || instance.courses.length)
        return favoritesInstance ? [favoritesInstance, ...filteredInstance] : filteredInstance
      },
      /**
       * aggregate favorite courses from each moodle instance
       *
       * @return {MoodleCourse[]}
       */
      favoriteCourses: function () {
        return this.moodleInstances.reduce((favoriteCourses, instance) =>
            favoriteCourses.concat(instance.courses.reduce((favorites, course) =>
                course.isFavorite
                    ? [ ...favorites, {...course, uniqueCourseId: `${course.courseId}_0`}]
                    : favorites
                , []
            )), []
        )
      },
      /**
       * compute user defaultMoodleViewMode setting
       * with its action on changeView button to return
       * - the component used to display courses list or tile
       * - the icon and text to display changeView button
       *
       * @return {{changeText: string, changeIcon: string, component: VueComponent}}
       */
      currentView: function(){
        let viewIndex = this.defaultView ? 1 : 0
        if(this.defaultMoodleViewMode === 'tiles') {
          viewIndex = (viewIndex + 1) % 2
        }
        return [
          {
            component: courseIcons,
            changeIcon: 'mdi-view-list',
            changeText: this.$t('course.changeViewText.toList')
          },
          {
            component: courseList,
            changeIcon: 'mdi-view-module',
            changeText: this.$t('course.changeViewText.toTiles')
          },
        ][viewIndex]

      },
      help() {
        return {
          title: this.$t('course.helper.title'),
          text: this.$t('course.helper.text', {publicPath: this.publicPath})
        }
      }
    },
    methods: {
      changeView: function(){
        this.defaultView = !this.defaultView
      }
    },
  }
</script>

<style scoped lang="scss">
  .v-expansion-panel-content::v-deep {
    .v-expansion-panel-content__wrap {
      padding: 13px 0 25px;
    }
  }
</style>
